import { matchPath } from "react-router";

export const isNavigationPathActive = (pathname: string, href: string): boolean =>
  Boolean(matchPath({ path: href, end: href === "/" }, pathname));
